// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web-analytics-tabs-dashboard {
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 0 0.5rem 0.5rem;
  overflow: visible;
  /* Keeps hover tooltips inside the channel rows above the neighbouring panel. */
}
@media (max-width: 600px) {
  .web-analytics-tabs-dashboard {
    padding: 0 0.25rem 0.5rem;
    max-width: 100%;
  }
}
.web-analytics-tabs-dashboard--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}
.web-analytics-tabs-dashboard__no-data {
  font-size: 15px;
  color: #8a9bb8;
  font-weight: 500;
}
.web-analytics-tabs-dashboard__tabs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  width: fit-content;
  max-width: 100%;
  margin: 0 0 12px;
  padding: 6px;
  border: 0;
  border-radius: 14px;
  background: #edf1f6;
}
.web-analytics-tabs-dashboard__tab {
  min-height: 40px;
  padding: 8px 18px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  color: #64748b;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: none;
  transition: color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}
@media (max-width: 600px) {
  .web-analytics-tabs-dashboard__tab {
    padding: 10px 12px;
    font-size: 12px;
  }
}
.web-analytics-tabs-dashboard__tab:hover {
  color: #111827;
  background: rgba(255, 255, 255, 0.56);
}
.web-analytics-tabs-dashboard__tab--active {
  color: #111827;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}
.web-analytics-tabs-dashboard__card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  padding: 1.5rem;
  margin-top: 5px;
  overflow: visible;
}
@media (max-width: 600px) {
  .web-analytics-tabs-dashboard__card {
    padding: 1rem;
  }
}
.web-analytics-tabs-dashboard__metric-heading {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 10px;
  color: #263145;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
}
.web-analytics-tabs-dashboard__metric-heading-help {
  width: 16px;
  height: 16px;
  border: 1px solid #d1dae8;
  border-radius: 50%;
  background: #f4f7fc;
  color: #7f93ad;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
  font-weight: 700;
}
.web-analytics-tabs-dashboard__metric-heading .definition-tooltip {
  margin-inline-start: 0;
}
.web-analytics-tabs-dashboard__cols {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 2rem;
  align-items: start;
  overflow: visible;
}
@media (max-width: 1100px) {
  .web-analytics-tabs-dashboard__cols {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
@media (max-width: 600px) {
  .web-analytics-tabs-dashboard__cols {
    gap: 1rem;
  }
}
.web-analytics-tabs-dashboard__section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #03045e;
  margin-bottom: 1rem;
}
.web-analytics-tabs-dashboard__panel {
  min-width: 0;
  background: #ffffff;
  border: 1px solid #e8edf4;
  border-radius: 14px;
  padding: 24px 26px 26px;
  overflow: visible;
}
@media (max-width: 700px) {
  .web-analytics-tabs-dashboard__panel {
    padding: 18px 14px 20px;
  }
}
.web-analytics-tabs-dashboard__panel--channels {
  position: relative;
  z-index: 4;
}
.web-analytics-tabs-dashboard__demographics {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  align-items: start;
  gap: 8px;
  margin-top: 1.5rem;
}
@media (max-width: 1099px) {
  .web-analytics-tabs-dashboard__demographics {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 4px;
  }
  .web-analytics-tabs-dashboard__demographics .demographics-age {
    grid-column: 1/-1;
  }
}
@media (max-width: 900px) {
  .web-analytics-tabs-dashboard__demographics {
    grid-template-columns: 1fr;
    gap: 0;
    margin-top: 1rem;
  }
}

@media (max-width: 768px) {
  .web-analytics-tabs-dashboard__tabs {
    display: flex;
    width: 100%;
    margin-bottom: 14px;
  }
}
.demographics-subtitle {
  font-size: 14px !important;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.demographics-hint {
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 8px;
}

.web-analytics-tabs-dashboard__section-title {
  font-size: 16px;
  font-weight: 800;
  color: #263145;
  margin-bottom: 12px;
}

.web-analytics-tabs-dashboard__section-title--with-tooltip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.top-locations {
  overflow: visible;
}

.top-locations__controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin: 16px 0 20px;
}

.top-locations__rows-per-page {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #53647c;
  font-size: 12px;
  font-weight: 600;
}

.top-locations__count-input {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.top-locations__count-input input {
  width: 56px;
  height: 30px;
  padding: 0 20px 0 6px;
  border: 1px solid #d7e1ee;
  border-radius: 6px;
  background: #ffffff;
  color: #2d3a4f;
  font-size: 12px;
  font-weight: 700;
}

.top-locations__count-steppers {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.top-locations__count-stepper-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 11px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}
.top-locations__count-stepper-button:hover:not(:disabled) {
  color: #2447b8;
}
.top-locations__count-stepper-button:disabled {
  color: #cbd5e1;
  cursor: not-allowed;
}

.top-locations__segmented {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border: 1px solid #d7e1ee;
  border-radius: 8px;
  background: #f8fafc;
}

.top-locations__segmented-button {
  min-width: 68px;
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}
.top-locations__segmented-button--active {
  background: #ffffff;
  color: #0f172a;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.top-locations-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.top-locations-list__row {
  display: grid;
  grid-template-columns: minmax(72px, 104px) minmax(120px, 1fr) minmax(64px, max-content);
  align-items: center;
  gap: 14px;
  min-height: 20px;
}

.top-locations-list__label {
  min-width: 0;
  color: #53647c;
  font-size: 13px !important;
  font-weight: 500;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-locations-list__track {
  position: relative;
  display: block;
  width: 100%;
  height: 14px;
  overflow: hidden;
  background: #e3e9f1;
  border-radius: 999px;
}

.top-locations-list__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
}

.top-locations-list__value {
  color: #2d3a4f;
  font-size: 13px !important;
  font-weight: 800;
  line-height: 1.15;
  text-align: end;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .top-locations-list {
    gap: 10px;
  }
  .top-locations-list__row {
    grid-template-columns: minmax(64px, 88px) minmax(80px, 1fr) minmax(56px, max-content);
    gap: 8px;
  }
  .top-locations-list__label,
  .top-locations-list__value {
    font-size: 12px !important;
  }
  .top-locations-list__track {
    height: 10px;
  }
}
.web-analytics-unavailable {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 18px;
  border: 1px solid #edf1f6;
  border-radius: 12px;
  background: #f8fafc;
  text-align: center;
  margin-top: 10px;
}

.web-analytics-unavailable strong {
  color: #53647c;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.2;
}

.web-analytics-unavailable span {
  color: #718096;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
}

.web-analytics-unavailable--top-cities {
  min-height: 188px;
}

.web-analytics-unavailable--channel {
  min-height: 220px;
}

.demographics-subtitle {
  font-size: 0.875rem;
  font-weight: 600;
  color: #000000;
  margin-bottom: 4px;
}

.demographics-subtitle--with-tooltip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.demographics-hint {
  font-size: 0.75rem;
  color: #7b8aa6;
  margin-bottom: 8px;
  font-style: italic;
}

.demographics-age {
  min-width: 0;
  width: 100%;
  padding: 20px;
}
@media (max-width: 1280px) {
  .demographics-age {
    padding: 16px;
  }
}
@media (max-width: 900px) {
  .demographics-age {
    padding: 16px 4px 24px;
  }
}

.demographics-age-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 12px;
}

.demographics-age-list__row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 8px;
}

.demographics-age-list__header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}

.demographics-age-list__label {
  color: #8b98ad;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.2;
}

.demographics-age-list__stats {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  flex-shrink: 0;
  color: #1e5a9d;
  font-size: 11px;
  white-space: nowrap;
}

.demographics-age-list__value {
  font-weight: 700;
  color: currentColor;
}

.demographics-age-list__percent {
  color: currentColor;
  opacity: 0.72;
  font-size: 10px;
}

.demographics-age-list__track {
  position: relative;
  display: block;
  width: 100%;
  height: 12px;
  overflow: hidden;
  background: #e8edf4;
  border-radius: 4px;
}

.demographics-age-list__fill {
  display: block;
  height: 100%;
  border-radius: inherit;
}

.demographics-age-list__axis {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
  color: #b0bccd;
  font-size: 11px;
  font-weight: 500;
}

.demographics-donut {
  border: none;
  border-radius: 0;
  padding: 20px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: visible;
  min-width: 0;
  width: 100%;
  min-height: 180px;
  /**
   * Recharts positions pie tooltips with absolute \`left\`/\`top\` in an LTR coordinate system.
   * Pinning only \`.recharts-surface\` to LTR leaves the sibling tooltip wrapper inheriting
   * \`dir="rtl"\` from <html>, which pushes Gender/Device tooltips off-screen in Arabic.
   */
}
@media (max-width: 1280px) {
  .demographics-donut {
    padding: 16px;
  }
}
@media (max-width: 900px) {
  .demographics-donut {
    padding: 16px 4px 24px;
    min-height: 160px;
  }
}
.demographics-donut .recharts-wrapper,
.demographics-donut .recharts-pie,
.demographics-donut .recharts-surface {
  overflow: visible !important;
}
.demographics-donut .recharts-wrapper {
  direction: ltr;
}
.demographics-donut .recharts-surface {
  direction: ltr;
}
.demographics-donut .recharts-responsive-container {
  overflow: visible !important;
}
.demographics-donut .recharts-tooltip-wrapper {
  direction: ltr;
  pointer-events: none;
  z-index: 20;
}

[dir=rtl] .demographics-donut .analytics-chart-tooltip {
  direction: rtl;
}

/*
 * Donut chart with legend below. Capped and centered so the legend's value
 * column sits close to its label instead of stretching to the far edge of a
 * wide grid column (which also threw off the spacing between the three
 * Age/Gender/Device panels).
 */
.donut-with-legend {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: min(230px, 100%);
  min-width: 0;
  margin: 0 auto;
  position: relative;
  overflow: visible;
}

.donut-legend {
  list-style: none;
  margin: 0;
  padding: 8px 0 0;
  width: 100%;
  max-width: 100%;
  font-size: 11px;
  color: #4b5b75;
}
@media (max-width: 900px) {
  .donut-legend {
    font-size: 10px;
    padding: 6px 0 0;
  }
}
.donut-legend__item {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) max-content;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  min-width: 0;
}
.donut-legend__swatch {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 2px;
}
.donut-legend__name {
  min-width: 0;
  text-transform: lowercase;
  color: #5a6b82;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: normal;
  padding-inline-end: 4px;
}
.donut-legend__value {
  font-weight: 700;
  color: currentColor;
  white-space: nowrap;
}
.donut-legend__percent {
  color: currentColor;
  opacity: 0.72;
  font-size: 10px;
  white-space: nowrap;
}
.donut-legend__stats {
  justify-self: end;
  white-space: nowrap;
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
}

.donut-legend--device {
  max-width: 100%;
  height: auto;
}

.channel-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: visible;
}

.channel-row {
  display: grid;
  grid-template-columns: minmax(0, min(42%, 220px)) minmax(100px, 1.15fr) minmax(88px, 110px);
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
  position: relative;
  z-index: 1;
}
@media (max-width: 700px) {
  .channel-row {
    grid-template-columns: minmax(0, 1fr) 1fr 85px;
    gap: 6px;
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .channel-row {
    grid-template-columns: minmax(0, 1fr) 1fr 75px;
    gap: 4px;
    font-size: 11px;
  }
}
.channel-row:last-child {
  border-bottom: none;
}
.channel-row:hover {
  z-index: 25;
}
.channel-row__name {
  color: #1a1a1a;
  font-weight: 500;
}
.channel-row__value-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: stretch;
  min-width: 0;
  width: 100%;
}
.channel-row__value-bar {
  width: 54px;
  height: 12px;
  background: #1f4aa8;
  border-radius: 2px;
  display: inline-block;
}
.channel-row__change {
  font-weight: 600;
  text-align: end;
}
.channel-row__change--pos {
  color: #28a745;
}
.channel-row__change--neg {
  color: #e53935;
}

.analytics-chart-tooltip {
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  border: 1px solid #e5e7eb;
  overflow: hidden;
  padding: 0;
}
.analytics-chart-tooltip__bar {
  width: 4px;
  background: #2b74e4;
  flex-shrink: 0;
}
.analytics-chart-tooltip__content {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.analytics-chart-tooltip__label {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.analytics-chart-tooltip__value {
  font-size: 14px;
  font-weight: 700;
  color: #03045e;
  white-space: nowrap;
}

.analytics-chart-tooltip--channel {
  min-width: 190px;
  height: 100px;
}

.analytics-chart-tooltip--city {
  min-width: 150px;
  max-width: 240px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
  background: #ffffff;
}
.analytics-chart-tooltip--city .analytics-chart-tooltip__bar {
  width: 4px;
  background: #2b74e4;
}
.analytics-chart-tooltip--city .analytics-chart-tooltip__content {
  padding: 10px 14px;
  gap: 3px;
}
.analytics-chart-tooltip--city .analytics-chart-tooltip__label,
.analytics-chart-tooltip--city .analytics-chart-tooltip__value {
  color: #5f6f87;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  white-space: nowrap;
}
.analytics-chart-tooltip--city .analytics-chart-tooltip__label strong,
.analytics-chart-tooltip--city .analytics-chart-tooltip__value strong {
  color: #2b5faa;
  font-weight: 800;
}

.analytics-chart-tooltip--age .analytics-chart-tooltip__percent {
  font-size: 14px;
  font-weight: 700;
  color: #2c68ad;
  margin-top: 2px;
}

.analytics-chart-tooltip__meta {
  font-size: 12px;
  color: #6b7280;
}

.analytics-chart-tooltip__content .analytics-chart-tooltip__meta strong {
  color: #000000;
}

.web-analytics-tabs-dashboard .recharts-tooltip-wrapper {
  z-index: 20;
}

.web-analytics-tabs-dashboard .recharts-default-tooltip {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
}

/* --- Channel performance bars + hover tooltip (match screenshot 01) --- */
.channel-row {
  grid-template-columns: minmax(0, min(42%, 220px)) minmax(100px, 1.15fr) minmax(88px, 110px);
}
@media (max-width: 700px) {
  .channel-row {
    grid-template-columns: minmax(0, 1fr) 1fr 85px;
  }
}
@media (max-width: 480px) {
  .channel-row {
    grid-template-columns: minmax(0, 1fr) 1fr 75px;
  }
}

.channel-row__bar {
  position: relative;
  flex: 1 1;
  width: 100%;
  max-width: 100%;
  min-width: 72px;
  height: 12px;
  background: transparent;
  border-radius: 2px;
  overflow: hidden;
  cursor: pointer;
}
@media (max-width: 700px) {
  .channel-row__bar {
    max-width: 92px;
    min-width: 50px;
  }
}
@media (max-width: 480px) {
  .channel-row__bar {
    max-width: 80px;
    min-width: 40px;
  }
}

.channel-row__bar-fill {
  display: block;
  height: 100%;
  background: #1f4aa8;
}

.channel-row__bar-tooltip {
  position: absolute;
  right: 0;
  top: 20px;
  z-index: 10;
  pointer-events: none;
}

.channel-row__bar-tooltip::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #2b74e4;
  border-radius: 6px 0 0 6px;
}

.channel-row__bar-tooltip-title {
  font-weight: 700;
  color: #1f4aa8;
  margin-bottom: 6px;
  font-size: 0.85rem;
}

.channel-row__bar-tooltip-row {
  font-size: 0.75rem;
  color: #6f7f98;
  margin-bottom: 4px;
}

.channel-row__bar-tooltip-row strong {
  color: #1f4aa8;
  font-weight: 600;
}

.analytics-chart-tooltip--channel {
  min-width: 220px;
  border-radius: 6px;
  border: 1px solid #d9e4f2;
  box-shadow: 0 8px 18px rgba(30, 42, 70, 0.18);
}

.analytics-chart-tooltip__label {
  font-weight: 700;
  font-size: 11px;
  color: #6b7280;
}

.analytics-chart-tooltip__value {
  font-weight: 700;
  font-size: 11px;
  color: #2c68ad;
}

.analytics-chart-tooltip__meta {
  font-size: 11px;
}

.channel-row__value-bar {
  display: none !important;
}

.channel-row__value-wrap {
  position: relative;
}

.channel-row__change--pos {
  color: #2f8f4e !important;
}

.channel-row__change--neg {
  color: #d93025 !important;
}

/* AntD tooltip for channel bar */
.channel-bar-tooltip .ant-tooltip-inner {
  background: #ffffff;
  border: 1px solid #d9e4f2;
  box-shadow: 0 8px 18px rgba(30, 42, 70, 0.18);
  padding: 10px 12px;
  border-radius: 6px;
  color: #6f7f98;
}

.channel-bar-tooltip .ant-tooltip-arrow::before {
  background: #ffffff;
  border: 1px solid #d9e4f2;
}

.channel-bar-tooltip__title {
  font-weight: 700;
  color: #1f4aa8;
  margin-bottom: 6px;
  font-size: 0.85rem;
}

.channel-bar-tooltip__row {
  font-size: 0.75rem;
  color: #6f7f98;
  margin-bottom: 4px;
}

.channel-bar-tooltip__row strong {
  color: #1f4aa8;
  font-weight: 600;
}

.channel-row {
  display: grid;
  grid-template-columns: minmax(0, min(42%, 220px)) minmax(100px, 1.15fr) minmax(88px, 110px);
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
}
@media (max-width: 700px) {
  .channel-row {
    grid-template-columns: minmax(0, 1fr) 1fr 85px;
    gap: 6px;
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .channel-row {
    grid-template-columns: minmax(0, 1fr) 1fr 75px;
    gap: 4px;
    font-size: 11px;
  }
}
.channel-row:last-child {
  border-bottom: none;
}
.channel-row__name {
  color: #1a1a1a;
  font-weight: 500;
}
.channel-row__value-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: stretch;
  min-width: 0;
  width: 100%;
}
.channel-row__bar {
  position: relative;
  flex: 1 1;
  width: 100%;
  max-width: 100%;
  min-width: 72px;
  height: 12px;
  background: #e8eef5;
  border-radius: 2px;
  overflow: visible;
  cursor: pointer;
}
@media (max-width: 700px) {
  .channel-row__bar {
    max-width: 92px;
    min-width: 50px;
  }
}
@media (max-width: 480px) {
  .channel-row__bar {
    max-width: 80px;
    min-width: 40px;
  }
}
.channel-row__bar-fill {
  display: block;
  height: 100%;
  background: #1f4aa8;
  border-radius: 2px;
  transition: width 0.3s ease;
}
.channel-row__change {
  font-weight: 600;
  text-align: end;
}
.channel-row__change--pos {
  color: #2f8f4e;
}
.channel-row__change--neg {
  color: #d93025;
}

.channel-row__bar-tooltip {
  position: absolute;
  background: white;
  border: 1px solid #e5eaf2;
  border-radius: 10px;
  box-shadow: 0 18px 28px rgba(24, 35, 56, 0.16);
  z-index: 1200;
  min-width: 344px;
  bottom: calc(100% + 14px);
  top: auto;
  right: -144px;
  pointer-events: none;
}
.channel-row__bar-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  border: 5px solid transparent;
  border-top-color: white;
}
.channel-row__bar-tooltip::before {
  content: "";
  position: absolute;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  border: 6px solid transparent;
  border-top-color: #e5eaf2;
  margin-top: 1px;
}

.kpi-graph-tooltip__bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #1f4aa8;
  border-radius: 6px 0 0 6px;
}
.kpi-graph-tooltip__content {
  padding: 14px 14px 16px;
}
.kpi-graph-tooltip__title {
  margin-bottom: 10px;
  color: #7b879b;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
}
.kpi-graph-tooltip__comparison {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 12px;
  align-items: end;
}
.kpi-graph-tooltip__metric {
  display: flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
}
.kpi-graph-tooltip__metric strong {
  color: #2f68bf;
  font-size: 15px;
  font-weight: 800;
  line-height: 1;
}
.kpi-graph-tooltip__metric span {
  color: #7b879b;
  font-size: 10px;
  font-weight: 500;
}
.kpi-graph-tooltip__vs {
  align-self: center;
  color: #7b879b;
  font-size: 10px;
  font-weight: 600;
}
.kpi-graph-tooltip__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-size: 11px;
}
.kpi-graph-tooltip__meta {
  color: #6f7f98;
  font-size: 11px;
}
.kpi-graph-tooltip__meta-value {
  color: #1f4aa8;
  font-weight: 600;
  margin-inline-start: 4px;
}
.kpi-graph-tooltip__divider {
  height: 1px;
  background: #e5e7eb;
  margin: 8px 0;
}
.kpi-graph-tooltip__mom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.kpi-graph-tooltip__mom-label {
  color: #6f7f98;
  font-size: 12px;
}
.kpi-graph-tooltip__mom-value {
  font-weight: 600;
  font-size: 12px;
}
.kpi-graph-tooltip__mom-value--positive {
  color: #2f8f4e;
}
.kpi-graph-tooltip__mom-value--negative {
  color: #d93025;
}

.web-analytics-tabs-dashboard .channel-list {
  gap: 0;
  margin-top: 12px;
}

.web-analytics-tabs-dashboard .channel-row {
  grid-template-columns: minmax(0, 180px) minmax(140px, 1fr) minmax(110px, 144px);
  gap: 8px;
  min-height: 42px;
  padding: 0;
  border-bottom: 0;
  font-size: 14px;
}

.web-analytics-tabs-dashboard .channel-row__name {
  color: #53647c;
  font-weight: 500;
}

.web-analytics-tabs-dashboard .channel-row__bar {
  min-width: 0;
  height: 9px;
  background: #e8edf4;
  border-radius: 999px;
  overflow: visible;
}

.web-analytics-tabs-dashboard .channel-row__bar-fill {
  background: #2447b8;
  border-radius: 999px;
}

.web-analytics-tabs-dashboard .channel-row__change {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 800;
  text-align: center;
}

.web-analytics-tabs-dashboard .channel-row__change--pos {
  color: #2f8f4e !important;
}

.web-analytics-tabs-dashboard .channel-row__change--neg {
  color: #ff4b4f !important;
}

.web-analytics-tabs-dashboard .channel-row__change svg {
  width: 11px;
  height: 11px;
  stroke-width: 2.6;
}

@media (max-width: 1000px) {
  .web-analytics-tabs-dashboard .channel-row__bar-tooltip {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    min-width: 220px;
    max-width: min(280px, 100vw - 180px);
    bottom: calc(100% + 10px);
  }
  .web-analytics-tabs-dashboard .channel-row__bar-tooltip::after {
    right: calc(50% - 5px);
  }
  .web-analytics-tabs-dashboard .channel-row__bar-tooltip::before {
    right: calc(50% - 6px);
  }
}
@media (max-width: 900px) {
  .web-analytics-tabs-dashboard .channel-row {
    grid-template-columns: minmax(0, min(40%, 200px)) minmax(90px, 1.1fr) minmax(78px, 98px);
    gap: 8px;
  }
}
@media (max-width: 700px) {
  .web-analytics-tabs-dashboard .channel-row {
    grid-template-columns: minmax(0, 1fr) minmax(70px, 1fr) minmax(78px, 98px);
    align-items: center;
    gap: 8px;
    padding: 8px 0;
  }
  .web-analytics-tabs-dashboard .channel-row__change {
    font-size: 12px;
  }
  .web-analytics-tabs-dashboard .channel-row__bar {
    max-width: 92px;
  }
}
@media (max-width: 480px) {
  .web-analytics-tabs-dashboard .channel-row {
    grid-template-columns: minmax(0, 1fr) minmax(62px, 80px) minmax(64px, 84px);
    gap: 6px;
  }
  .web-analytics-tabs-dashboard .channel-row__change {
    font-size: 11px;
  }
  .web-analytics-tabs-dashboard .channel-row__bar {
    max-width: 80px;
    height: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/webAnalytics/components/Tabs/TabsDashboard.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,iBAAA;EAkJA,+EAAA;AAlJF;AAEE;EAPF;IAQI,yBAAA;IACA,eAAA;EACF;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACJ;AAEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAGE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0EAAA;AAFJ;AAII;EAdF;IAeI,kBAAA;IACA,eCgKS;EDjKb;AACF;AAGI;EACE,cAAA;EACA,qCAAA;AADN;AAII;EACE,cAAA;EACA,mBAAA;EACA,4CAAA;AAFN;AAME;EACE,mBC5DI;ED6DJ,mBCwIQ;EDvIR,yCCkHQ;EDjHR,yBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AAJJ;AAMI;EATF;IAUI,aAAA;EAHJ;AACF;AAME;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AALJ;AAQE;EACE,sBAAA;AANJ;AASE;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;AAPJ;AASI;EAPF;IAQI,0BAAA;IACA,WAAA;EANJ;AACF;AAQI;EAZF;IAaI,SAAA;EALJ;AACF;AAQE;EACE,iBAAA;EACA,gBCwFe;EDvFf,cCjIO;EDkIP,mBAAA;AANJ;AASE;EACE,YAAA;EACA,mBCjII;EDkIJ,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAPJ;AASI;EARF;IASI,uBAAA;EANJ;AACF;AAUE;EACE,kBAAA;EACA,UAAA;AARJ;AAWE;EACE,aAAA;EACA,mEAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;AATJ;AAWI;EAPF;IAQI,oDAAA;IACA,QAAA;EARJ;EAUI;IACE,iBAAA;EARN;AACF;AAWI;EAhBF;IAiBI,0BAAA;IACA,MAAA;IACA,gBAAA;EARJ;AACF;;AAYA;EACE;IACE,aAAA;IACA,WAAA;IACA,mBAAA;EATF;AACF;AAYA;EACE,0BAAA;EACA,gBC6BqB;ED5BrB,cChLa;EDiLb,kBAAA;AAVF;;AAaA;EACE,eCkBa;EDjBb,cCpLW;EDqLX,kBAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAVF;AAYE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAVJ;;AAkBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAfF;AAiBE;EACE,cAAA;AAfJ;AAkBE;EACE,cAAA;EACA,mBAAA;AAhBJ;;AAoBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAjBF;AAmBE;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,uFAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE;IACE,SAAA;EAlBF;EAqBA;IACE,qFAAA;IACA,QAAA;EAnBF;EAsBA;;IAEE,0BAAA;EApBF;EAuBA;IACE,YAAA;EArBF;AACF;AAwBA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,iBAAA;AAtBF;;AAyBA;EACE,iBAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,WAAA;EACA,aAAA;AAtBF;AAwBE;EALF;IAMI,aAAA;EArBF;AACF;AAuBE;EATF;IAUI,sBAAA;EApBF;AACF;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;AApBF;;AAuBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AApBF;;AAyBA;EACE,oBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EAiBA;;;;IAAA;AAlCF;AAmBE;EAbF;IAcI,aAAA;EAhBF;AACF;AAkBE;EAjBF;IAkBI,sBAAA;IACA,iBAAA;EAfF;AACF;AAiBE;;;EAGE,4BAAA;AAfJ;AAuBE;EACE,cAAA;AArBJ;AAwBE;EACE,cAAA;AAtBJ;AAyBE;EACE,4BAAA;AAvBJ;AA0BE;EACE,cAAA;EACA,oBAAA;EACA,WAAA;AAxBJ;;AA4BA;EACE,cAAA;AAzBF;;AA4BA;;;;;EAAA;AAMA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAzBF;AA2BE;EATF;IAUI,eAAA;IACA,gBAAA;EAxBF;AACF;AA0BE;EACE,aAAA;EACA,sDAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AAxBJ;AA2BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAzBJ;AA4BE;EACE,YAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AA1BJ;AA6BE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,QAAA;AA7BJ;;AAiCA;EACE,eAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,2FAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gCAAA;EACA,eC9da;ED+db,kBAAA;EACA,UAAA;AA9BF;AAgCE;EAXF;IAYI,8CAAA;IACA,QAAA;IACA,eCreW;EDwcb;AACF;AA+BE;EAjBF;IAkBI,8CAAA;IACA,QAAA;IACA,eAAA;EA5BF;AACF;AA8BE;EACE,mBAAA;AA5BJ;AA+BE;EACE,WAAA;AA7BJ;AAgCE;EACE,cC9rBW;ED+rBX,gBAAA;AA9BJ;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AAhCJ;AAmCE;EACE,gBAAA;EACA,eAAA;AAjCJ;AAmCI;EACE,cCzsBI;ADwqBV;AAoCI;EACE,cChtBG;AD8qBT;;AAuCA;EACE,aAAA;EACA,mBCxuBM;EDyuBN,kBCriBU;EDsiBV,yCCzjBU;ED0jBV,yBAAA;EACA,gBAAA;EACA,UAAA;AApCF;AAsCE;EACE,UAAA;EACA,mBAAA;EACA,cAAA;AApCJ;AAuCE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AArCJ;AAwCE;EACE,eCjjBW;EDkjBX,cCxvBa;EDyvBb,mBAAA;AAtCJ;AAyCE;EACE,eCtjBW;EDujBX,gBCljBe;EDmjBf,cC3wBO;ED4wBP,mBAAA;AAvCJ;;AA2CA;EACE,gBAAA;EACA,aAAA;AAxCF;;AA2CA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;EACA,mBAAA;AAxCF;AA0CE;EACE,UAAA;EACA,mBAAA;AAxCJ;AA2CE;EACE,kBAAA;EACA,QAAA;AAzCJ;AA4CE;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA1CJ;AA6CE;;EAEE,cAAA;EACA,gBAAA;AA3CJ;;AA+CA;EACE,eCrmBa;EDsmBb,gBCjmBiB;EDkmBjB,cC/zBc;EDg0Bd,eAAA;AA5CF;;AA+CA;EACE,eC7mBa;ED8mBb,cCpzBe;ADwwBjB;;AA+CA;EACE,cCrzBU;ADywBZ;;AA+CA;EACE,WAAA;AA5CF;;AA+CA;EACE,qBAAA;EACA,kCAAA;EACA,uBAAA;AA5CF;;AA+CA,2EAAA;AACA;EACE,2FAAA;AA5CF;AA8CE;EAHF;IAII,8CAAA;EA3CF;AACF;AA6CE;EAPF;IAQI,8CAAA;EA1CF;AACF;;AA6CA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA1CF;AA4CE;EAZF;IAaI,eAAA;IACA,eAAA;EAzCF;AACF;AA2CE;EAjBF;IAkBI,eAAA;IACA,eAAA;EAxCF;AACF;;AA2CA;EACE,cAAA;EACA,YAAA;EACA,mBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;AAxCF;;AA2CA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AAxCF;;AA2CA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAxCF;;AA2CA;EACE,cAAA;EACA,gBAAA;AAxCF;;AA2CA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6CAAA;AAxCF;;AA2CA;EACE,gBAAA;EACA,eAAA;EACA,cC95Be;ADs3BjB;;AA2CA;EACE,gBAAA;EACA,eAAA;EACA,cCr7Bc;AD64BhB;;AA2CA;EACE,eAAA;AAxCF;;AA2CA;EACE,wBAAA;AAxCF;;AA2CA;EACE,kBAAA;AAxCF;;AA2CA;EACE,yBAAA;AAxCF;;AA2CA;EACE,yBAAA;AAxCF;;AA2CA,iCAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAxCF;;AA2CA;EACE,mBAAA;EACA,yBAAA;AAxCF;;AA2CA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAxCF;;AA2CA;EACE,cAAA;EACA,gBAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,2FAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gCAAA;EACA,eC7xBa;ADqvBf;AA0CE;EATF;IAUI,8CAAA;IACA,QAAA;IACA,eAAA;EAvCF;AACF;AAyCE;EAfF;IAgBI,8CAAA;IACA,QAAA;IACA,eAAA;EAtCF;AACF;AAwCE;EACE,mBAAA;AAtCJ;AAyCE;EACE,cCv/BW;EDw/BX,gBAAA;AAvCJ;AA0CE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;AAxCJ;AA2CE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAzCJ;AA2CI;EAZF;IAaI,eAAA;IACA,eAAA;EAxCJ;AACF;AA0CI;EAjBF;IAkBI,eAAA;IACA,eAAA;EAvCJ;AACF;AA0CE;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AAxCJ;AA2CE;EACE,gBAAA;EACA,eAAA;AAzCJ;AA2CI;EACE,cAAA;AAzCN;AA4CI;EACE,cAAA;AA1CN;;AAgDA;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;AA7CF;AAgDE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,6BAAA;EACA,uBAAA;AA9CJ;AAiDE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBAAA;EACA,eAAA;AA/CJ;;AAoDE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,0BAAA;AAjDJ;AAoDE;EACE,uBAAA;AAlDJ;AAqDE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,mCAAA;EACA,SAAA;EACA,gBAAA;AApDJ;AAuDE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;AArDJ;AAwDE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtDJ;AAyDE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAvDJ;AA0DE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxDJ;AA2DE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAzDJ;AA4DE;EACE,cAAA;EACA,eAAA;AA1DJ;AA6DE;EACE,cAAA;EACA,gBAAA;EACA,wBAAA;AA3DJ;AA8DE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AA5DJ;AA+DE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AA7DJ;AAgEE;EACE,cAAA;EACA,eAAA;AA9DJ;AAiEE;EACE,gBAAA;EACA,eAAA;AA/DJ;AAiEI;EACE,cAAA;AA/DN;AAkEI;EACE,cAAA;AAhEN;;AAqEA;EACE,MAAA;EACA,gBAAA;AAlEF;;AAqEA;EACE,+EAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAlEF;;AAqEA;EACE,cAAA;EACA,gBAAA;AAlEF;;AAqEA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AAlEF;;AAqEA;EACE,mBAAA;EACD,oBAAA;AAlED;;AAqEA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAlEF;;AAqEA;EACE,yBAAA;AAlEF;;AAqEA;EACE,yBAAA;AAlEF;;AAqEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAlEF;;AAqEA;EACE;IACE,SAAA;IACA,WAAA;IACA,2BAAA;IACA,gBAAA;IACA,oCAAA;IACA,yBAAA;EAlEF;EAqEA;IACE,sBAAA;EAnEF;EAsEA;IACE,sBAAA;EApEF;AACF;AAuEA;EACE;IACE,wFAAA;IACA,QAAA;EArEF;AACF;AAwEA;EACE;IACE,0EAAA;IACA,mBAAA;IACA,QAAA;IACA,cAAA;EAtEF;EAyEA;IACE,eAAA;EAvEF;EA0EA;IACE,eAAA;EAxEF;AACF;AA2EA;EACE;IACE,2EAAA;IACA,QAAA;EAzEF;EA4EA;IACE,eAAA;EA1EF;EA6EA;IACE,eAAA;IACA,YAAA;EA3EF;AACF","sourcesContent":["@import \"../../../../styles/variables\";\n\n.web-analytics-tabs-dashboard {\n  max-width: 100%;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 0.5rem 0.5rem;\n  overflow: visible;\n\n  @media (max-width: 600px) {\n    padding: 0 0.25rem 0.5rem;\n    max-width: 100%;\n  }\n\n  &--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 120px;\n  }\n\n  &__no-data {\n    font-size: 15px;\n    color: #8a9bb8;\n    font-weight: 500;\n  }\n\n  &__tabs {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    flex-wrap: wrap;\n    width: fit-content;\n    max-width: 100%;\n    margin: 0 0 12px;\n    padding: 6px;\n    border: 0;\n    border-radius: 14px;\n    background: #edf1f6;\n  }\n\n  &__tab {\n    min-height: 40px;\n    padding: 8px 18px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.2;\n    color: #64748b;\n    background: transparent;\n    border: 0;\n    border-radius: 8px;\n    cursor: pointer;\n    box-shadow: none;\n    transition: color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;\n\n    @media (max-width: 600px) {\n      padding: 10px 12px;\n      font-size: $font-size-sm;\n    }\n\n    &:hover {\n      color: #111827;\n      background: rgba(255, 255, 255, 0.56);\n    }\n\n    &--active {\n      color: #111827;\n      background: #ffffff;\n      box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n    }\n  }\n\n  &__card {\n    background: $white;\n    border-radius: $radius-lg;\n    box-shadow: $shadow-sm;\n    border: 1px solid $border-light;\n    padding: 1.5rem;\n    margin-top: 5px;\n    overflow: visible;\n\n    @media (max-width: 600px) {\n      padding: 1rem;\n    }\n  }\n\n  &__metric-heading {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin: 0 0 10px;\n    color: #263145;\n    font-size: 16px;\n    font-weight: 800;\n    line-height: 1.2;\n  }\n\n  &__metric-heading-help {\n    width: 16px;\n    height: 16px;\n    border: 1px solid #d1dae8;\n    border-radius: 50%;\n    background: #f4f7fc;\n    color: #7f93ad;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    line-height: 1;\n    font-weight: 700;\n  }\n\n  &__metric-heading .definition-tooltip {\n    margin-inline-start: 0;\n  }\n\n  &__cols {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 2rem;\n    align-items: start;\n    overflow: visible;\n\n    @media (max-width: 1100px) {\n      grid-template-columns: 1fr;\n      gap: 1.5rem;\n    }\n\n    @media (max-width: 600px) {\n      gap: 1rem;\n    }\n  }\n\n  &__section-title {\n    font-size: 1.1rem;\n    font-weight: $font-weight-bold;\n    color: $blue-400;\n    margin-bottom: 1rem;\n  }\n\n  &__panel {\n    min-width: 0;\n    background: $white;\n    border: 1px solid #e8edf4;\n    border-radius: 14px;\n    padding: 24px 26px 26px;\n    overflow: visible;\n\n    @media (max-width: 700px) {\n      padding: 18px 14px 20px;\n    }\n  }\n\n  /* Keeps hover tooltips inside the channel rows above the neighbouring panel. */\n  &__panel--channels {\n    position: relative;\n    z-index: 4;\n  }\n\n  &__demographics {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n    align-items: start;\n    gap: 8px;\n    margin-top: 1.5rem;\n\n    @media (max-width: 1099px) {\n      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n      gap: 4px;\n\n      .demographics-age {\n        grid-column: 1 / -1;\n      }\n    }\n\n    @media (max-width: 900px) {\n      grid-template-columns: 1fr;\n      gap: 0;\n      margin-top: 1rem;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .web-analytics-tabs-dashboard__tabs {\n    display: flex;\n    width: 100%;\n    margin-bottom: 14px;\n  }\n}\n\n.demographics-subtitle {\n  font-size: 14px !important;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  margin-bottom: 4px;\n}\n\n.demographics-hint {\n  font-size: $font-size-sm;\n  color: $text-muted;\n  margin-bottom: 8px;\n}\n\n.web-analytics-tabs-dashboard__section-title {\n  font-size: 16px;\n  font-weight: 800;\n  color: #263145;\n  margin-bottom: 12px;\n}\n\n.web-analytics-tabs-dashboard__section-title--with-tooltip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.top-locations {\n  overflow: visible;\n}\n\n.top-locations__controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 16px 0 20px;\n}\n\n.top-locations__rows-per-page {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #53647c;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.top-locations__count-input {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n\n  input {\n    width: 56px;\n    height: 30px;\n    padding: 0 20px 0 6px;\n    border: 1px solid #d7e1ee;\n    border-radius: 6px;\n    background: #ffffff;\n    color: #2d3a4f;\n    font-size: 12px;\n    font-weight: 700;\n  }\n}\n\n// Custom stepper — built instead of relying on a native `type=\"number\"` input's\n// spin buttons, both because that field type has to be `text` (see comment at\n// the call site) and because a native spinner fades out until hover/focus by\n// default; this stays visible at all times.\n.top-locations__count-steppers {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.top-locations__count-stepper-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 11px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    color: #2447b8;\n  }\n\n  &:disabled {\n    color: #cbd5e1;\n    cursor: not-allowed;\n  }\n}\n\n.top-locations__segmented {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 3px;\n  border: 1px solid #d7e1ee;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.top-locations__segmented-button {\n  min-width: 68px;\n  height: 30px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n\n  &--active {\n    background: #ffffff;\n    color: #0f172a;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n  }\n}\n\n.top-locations-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.top-locations-list__row {\n  display: grid;\n  grid-template-columns: minmax(72px, 104px) minmax(120px, 1fr) minmax(64px, max-content);\n  align-items: center;\n  gap: 14px;\n  min-height: 20px;\n}\n\n.top-locations-list__label {\n  min-width: 0;\n  color: #53647c;\n  font-size: 13px !important;\n  font-weight: 500;\n  line-height: 1.15;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.top-locations-list__track {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 14px;\n  overflow: hidden;\n  background: #e3e9f1;\n  border-radius: 999px;\n}\n\n.top-locations-list__fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.top-locations-list__value {\n  color: #2d3a4f;\n  font-size: 13px !important;\n  font-weight: 800;\n  line-height: 1.15;\n  text-align: end;\n  white-space: nowrap;\n}\n\n@media (max-width: 600px) {\n  .top-locations-list {\n    gap: 10px;\n  }\n\n  .top-locations-list__row {\n    grid-template-columns: minmax(64px, 88px) minmax(80px, 1fr) minmax(56px, max-content);\n    gap: 8px;\n  }\n\n  .top-locations-list__label,\n  .top-locations-list__value {\n    font-size: 12px !important;\n  }\n\n  .top-locations-list__track {\n    height: 10px;\n  }\n}\n\n.web-analytics-unavailable {\n  min-height: 180px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 18px;\n  border: 1px solid #edf1f6;\n  border-radius: 12px;\n  background: #f8fafc;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.web-analytics-unavailable strong {\n  color: #53647c;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.web-analytics-unavailable span {\n  color: #718096;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.web-analytics-unavailable--top-cities {\n  min-height: 188px;\n}\n\n.web-analytics-unavailable--channel {\n  min-height: 220px;\n}\n\n.demographics-subtitle {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #000000;\n  margin-bottom: 4px;\n}\n\n.demographics-subtitle--with-tooltip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.demographics-hint {\n  font-size: 0.75rem;\n  color: #7b8aa6;\n  margin-bottom: 8px;\n  font-style: italic;\n}\n\n.demographics-age {\n  min-width: 0;\n  width: 100%;\n  padding: 20px;\n\n  @media (max-width: 1280px) {\n    padding: 16px;\n  }\n\n  @media (max-width: 900px) {\n    padding: 16px 4px 24px;\n  }\n}\n\n.demographics-age-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 12px;\n}\n\n.demographics-age-list__row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-bottom: 8px;\n}\n\n.demographics-age-list__header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n}\n\n.demographics-age-list__label {\n  color: #8b98ad;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n// Matches the donut legend value/percent treatment; the darker blue is the\n// legend-text stand-in for the primary bar fill so it stays readable on white.\n.demographics-age-list__stats {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 2px;\n  flex-shrink: 0;\n  color: #1e5a9d;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.demographics-age-list__value {\n  font-weight: 700;\n  color: currentColor;\n}\n\n.demographics-age-list__percent {\n  color: currentColor;\n  opacity: 0.72;\n  font-size: 10px;\n}\n\n.demographics-age-list__track {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 12px;\n  overflow: hidden;\n  background: #e8edf4;\n  border-radius: 4px;\n}\n\n.demographics-age-list__fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.demographics-age-list__axis {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 2px;\n  color: #b0bccd;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.demographics-donut {\n  border: none;\n  border-radius: 0;\n  padding: 20px;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  overflow: visible;\n  min-width: 0;\n  width: 100%;\n  min-height: 180px;\n\n  @media (max-width: 1280px) {\n    padding: 16px;\n  }\n\n  @media (max-width: 900px) {\n    padding: 16px 4px 24px;\n    min-height: 160px;\n  }\n\n  .recharts-wrapper,\n  .recharts-pie,\n  .recharts-surface {\n    overflow: visible !important;\n  }\n\n  /**\n   * Recharts positions pie tooltips with absolute `left`/`top` in an LTR coordinate system.\n   * Pinning only `.recharts-surface` to LTR leaves the sibling tooltip wrapper inheriting\n   * `dir=\"rtl\"` from <html>, which pushes Gender/Device tooltips off-screen in Arabic.\n   */\n  .recharts-wrapper {\n    direction: ltr;\n  }\n\n  .recharts-surface {\n    direction: ltr;\n  }\n\n  .recharts-responsive-container {\n    overflow: visible !important;\n  }\n\n  .recharts-tooltip-wrapper {\n    direction: ltr;\n    pointer-events: none;\n    z-index: 20;\n  }\n}\n\n[dir=\"rtl\"] .demographics-donut .analytics-chart-tooltip {\n  direction: rtl;\n}\n\n/*\n * Donut chart with legend below. Capped and centered so the legend's value\n * column sits close to its label instead of stretching to the far edge of a\n * wide grid column (which also threw off the spacing between the three\n * Age/Gender/Device panels).\n */\n.donut-with-legend {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: min(230px, 100%);\n  min-width: 0;\n  margin: 0 auto;\n  position: relative;\n  overflow: visible;\n}\n\n.donut-legend {\n  list-style: none;\n  margin: 0;\n  padding: 8px 0 0;\n  width: 100%;\n  max-width: 100%;\n  font-size: 11px;\n  color: #4b5b75;\n\n  @media (max-width: 900px) {\n    font-size: 10px;\n    padding: 6px 0 0;\n  }\n\n  &__item {\n    display: grid;\n    grid-template-columns: 10px minmax(0, 1fr) max-content;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 0;\n    min-width: 0;\n  }\n\n  &__swatch {\n    flex-shrink: 0;\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n  }\n\n  &__name {\n    min-width: 0;\n    text-transform: lowercase;\n    color: #5a6b82;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    word-break: normal;\n    padding-inline-end: 4px;\n  }\n\n  &__value {\n    font-weight: 700;\n    color: currentColor;\n    white-space: nowrap;\n  }\n\n  &__percent {\n    color: currentColor;\n    opacity: 0.72;\n    font-size: 10px;\n    white-space: nowrap;\n  }\n\n  &__stats {\n    justify-self: end;\n    white-space: nowrap;\n    display: inline-flex;\n    align-items: baseline;\n    gap: 2px;\n  }\n}\n\n.donut-legend--device {\n  max-width: 100%;\n  height: auto;\n}\n\n.channel-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow: visible;\n}\n\n.channel-row {\n  display: grid;\n  grid-template-columns: minmax(0, min(42%, 220px)) minmax(100px, 1.15fr) minmax(88px, 110px);\n  align-items: center;\n  gap: 8px;\n  padding: 6px 0;\n  border-bottom: 1px solid $border-light;\n  font-size: $font-size-sm;\n  position: relative;\n  z-index: 1;\n\n  @media (max-width: 700px) {\n    grid-template-columns: minmax(0, 1fr) 1fr 85px;\n    gap: 6px;\n    font-size: $font-size-sm;\n  }\n\n  @media (max-width: 480px) {\n    grid-template-columns: minmax(0, 1fr) 1fr 75px;\n    gap: 4px;\n    font-size: 11px;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &:hover {\n    z-index: 25;\n  }\n\n  &__name {\n    color: $text-primary;\n    font-weight: 500;\n  }\n\n  &__value-wrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    justify-content: stretch;\n    min-width: 0;\n    width: 100%;\n  }\n\n  &__value-bar {\n    width: 54px;\n    height: 12px;\n    background: #1f4aa8;\n    border-radius: 2px;\n    display: inline-block;\n  }\n\n  &__change {\n    font-weight: 600;\n    text-align: end;\n\n    &--pos {\n      color: $success;\n    }\n\n    &--neg {\n      color: $danger;\n    }\n  }\n}\n\n.analytics-chart-tooltip {\n  display: flex;\n  background: $white;\n  border-radius: $radius-md;\n  box-shadow: $shadow-md;\n  border: 1px solid $border-light;\n  overflow: hidden;\n  padding: 0;\n\n  &__bar {\n    width: 4px;\n    background: #2b74e4;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    padding: 8px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__label {\n    font-size: $font-size-sm;\n    color: $text-secondary;\n    white-space: nowrap;\n  }\n\n  &__value {\n    font-size: $font-size-md;\n    font-weight: $font-weight-bold;\n    color: $blue-400;\n    white-space: nowrap;\n  }\n}\n\n.analytics-chart-tooltip--channel {\n  min-width: 190px;\n  height: 100px;\n}\n\n.analytics-chart-tooltip--city {\n  min-width: 150px;\n  max-width: 240px;\n  border: 1px solid #dbe3ef;\n  border-radius: 8px;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);\n  background: #ffffff;\n\n  .analytics-chart-tooltip__bar {\n    width: 4px;\n    background: #2b74e4;\n  }\n\n  .analytics-chart-tooltip__content {\n    padding: 10px 14px;\n    gap: 3px;\n  }\n\n  .analytics-chart-tooltip__label,\n  .analytics-chart-tooltip__value {\n    color: #5f6f87;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.35;\n    white-space: nowrap;\n  }\n\n  .analytics-chart-tooltip__label strong,\n  .analytics-chart-tooltip__value strong {\n    color: #2b5faa;\n    font-weight: 800;\n  }\n}\n\n.analytics-chart-tooltip--age .analytics-chart-tooltip__percent {\n  font-size: $font-size-md;\n  font-weight: $font-weight-bold;\n  color: $brand-primary;\n  margin-top: 2px;\n}\n\n.analytics-chart-tooltip__meta {\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n.analytics-chart-tooltip__content .analytics-chart-tooltip__meta strong {\n  color: $text-dark;\n}\n\n.web-analytics-tabs-dashboard .recharts-tooltip-wrapper {\n  z-index: 20;\n}\n\n.web-analytics-tabs-dashboard .recharts-default-tooltip {\n  padding: 0 !important;\n  background: transparent !important;\n  border: none !important;\n}\n\n/* --- Channel performance bars + hover tooltip (match screenshot 01) --- */\n.channel-row {\n  grid-template-columns: minmax(0, min(42%, 220px)) minmax(100px, 1.15fr) minmax(88px, 110px);\n\n  @media (max-width: 700px) {\n    grid-template-columns: minmax(0, 1fr) 1fr 85px;\n  }\n\n  @media (max-width: 480px) {\n    grid-template-columns: minmax(0, 1fr) 1fr 75px;\n  }\n}\n\n.channel-row__bar {\n  position: relative;\n  flex: 1;\n  width: 100%;\n  max-width: 100%;\n  min-width: 72px;\n  height: 12px;\n  background: transparent;\n  border-radius: 2px;\n  overflow: hidden;\n  cursor: pointer;\n\n  @media (max-width: 700px) {\n    max-width: 92px;\n    min-width: 50px;\n  }\n\n  @media (max-width: 480px) {\n    max-width: 80px;\n    min-width: 40px;\n  }\n}\n\n.channel-row__bar-fill {\n  display: block;\n  height: 100%;\n  background: #1f4aa8;\n}\n\n.channel-row__bar-tooltip {\n  position: absolute;\n  right: 0;\n  top: 20px;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.channel-row__bar-tooltip::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: #2b74e4;\n  border-radius: 6px 0 0 6px;\n}\n\n.channel-row__bar-tooltip-title {\n  font-weight: 700;\n  color: #1f4aa8;\n  margin-bottom: 6px;\n  font-size: 0.85rem;\n}\n\n.channel-row__bar-tooltip-row {\n  font-size: 0.75rem;\n  color: #6f7f98;\n  margin-bottom: 4px;\n}\n\n.channel-row__bar-tooltip-row strong {\n  color: #1f4aa8;\n  font-weight: 600;\n}\n\n.analytics-chart-tooltip--channel {\n  min-width: 220px;\n  border-radius: 6px;\n  border: 1px solid #d9e4f2;\n  box-shadow: 0 8px 18px rgba(30, 42, 70, 0.18);\n}\n\n.analytics-chart-tooltip__label {\n  font-weight: 700;\n  font-size: 11px;\n  color: $text-secondary;\n}\n\n.analytics-chart-tooltip__value {\n  font-weight: 700;\n  font-size: 11px;\n  color: $brand-primary;\n}\n\n.analytics-chart-tooltip__meta {\n  font-size: 11px;\n}\n\n.channel-row__value-bar {\n  display: none !important;\n}\n\n.channel-row__value-wrap {\n  position: relative;\n}\n\n.channel-row__change--pos {\n  color: #2f8f4e !important;\n}\n\n.channel-row__change--neg {\n  color: #d93025 !important;\n}\n\n/* AntD tooltip for channel bar */\n.channel-bar-tooltip .ant-tooltip-inner {\n  background: #ffffff;\n  border: 1px solid #d9e4f2;\n  box-shadow: 0 8px 18px rgba(30, 42, 70, 0.18);\n  padding: 10px 12px;\n  border-radius: 6px;\n  color: #6f7f98;\n}\n\n.channel-bar-tooltip .ant-tooltip-arrow::before {\n  background: #ffffff;\n  border: 1px solid #d9e4f2;\n}\n\n.channel-bar-tooltip__title {\n  font-weight: 700;\n  color: #1f4aa8;\n  margin-bottom: 6px;\n  font-size: 0.85rem;\n}\n\n.channel-bar-tooltip__row {\n  font-size: 0.75rem;\n  color: #6f7f98;\n  margin-bottom: 4px;\n}\n\n.channel-bar-tooltip__row strong {\n  color: #1f4aa8;\n  font-weight: 600;\n}\n\n.channel-row {\n  display: grid;\n  grid-template-columns: minmax(0, min(42%, 220px)) minmax(100px, 1.15fr) minmax(88px, 110px);\n  align-items: center;\n  gap: 8px;\n  padding: 6px 0;\n  border-bottom: 1px solid $border-light;\n  font-size: $font-size-sm;\n\n  @media (max-width: 700px) {\n    grid-template-columns: minmax(0, 1fr) 1fr 85px;\n    gap: 6px;\n    font-size: 12px;\n  }\n\n  @media (max-width: 480px) {\n    grid-template-columns: minmax(0, 1fr) 1fr 75px;\n    gap: 4px;\n    font-size: 11px;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  &__name {\n    color: $text-primary;\n    font-weight: 500;\n  }\n\n  &__value-wrap {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: stretch;\n    min-width: 0;\n    width: 100%;\n  }\n\n  &__bar {\n    position: relative;\n    flex: 1;\n    width: 100%;\n    max-width: 100%;\n    min-width: 72px;\n    height: 12px;\n    background: #e8eef5;\n    border-radius: 2px;\n    overflow: visible; // Important for tooltip to show\n    cursor: pointer;\n\n    @media (max-width: 700px) {\n      max-width: 92px;\n      min-width: 50px;\n    }\n\n    @media (max-width: 480px) {\n      max-width: 80px;\n      min-width: 40px;\n    }\n  }\n\n  &__bar-fill {\n    display: block;\n    height: 100%;\n    background: #1f4aa8;\n    border-radius: 2px;\n    transition: width 0.3s ease;\n  }\n\n  &__change {\n    font-weight: 600;\n    text-align: end;\n\n    &--pos {\n      color: #2f8f4e;\n    }\n\n    &--neg {\n      color: #d93025;\n    }\n  }\n}\n\n// Tooltip for the bar\n.channel-row__bar-tooltip {\n  position: absolute;\n  background: white;\n  border: 1px solid #e5eaf2;\n  border-radius: 10px;\n  box-shadow: 0 18px 28px rgba(24, 35, 56, 0.16);\n  z-index: 1200;\n  min-width: 344px;\n  bottom: calc(100% + 14px);\n  top: auto;\n  right: -144px;\n  pointer-events: none;\n\n  // Arrow pointing down\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    right: 50%;\n    transform: translateX(50%);\n    border: 5px solid transparent;\n    border-top-color: white;\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    right: 50%;\n    transform: translateX(50%);\n    border: 6px solid transparent;\n    border-top-color: #e5eaf2;\n    margin-top: 1px;\n  }\n}\n\n.kpi-graph-tooltip {\n  &__bar {\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    background: #1f4aa8;\n    border-radius: 6px 0 0 6px;\n  }\n\n  &__content {\n    padding: 14px 14px 16px;\n  }\n\n  &__title {\n    margin-bottom: 10px;\n    color: #7b879b;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__comparison {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    gap: 12px;\n    align-items: end;\n  }\n\n  &__metric {\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n    white-space: nowrap;\n  }\n\n  &__metric strong {\n    color: #2f68bf;\n    font-size: 15px;\n    font-weight: 800;\n    line-height: 1;\n  }\n\n  &__metric span {\n    color: #7b879b;\n    font-size: 10px;\n    font-weight: 500;\n  }\n\n  &__vs {\n    align-self: center;\n    color: #7b879b;\n    font-size: 10px;\n    font-weight: 600;\n  }\n\n  &__row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n    font-size: 11px;\n  }\n\n  &__meta {\n    color: #6f7f98;\n    font-size: 11px;\n  }\n\n  &__meta-value {\n    color: #1f4aa8;\n    font-weight: 600;\n    margin-inline-start: 4px;\n  }\n\n  &__divider {\n    height: 1px;\n    background: #e5e7eb;\n    margin: 8px 0;\n  }\n\n  &__mom-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0;\n  }\n\n  &__mom-label {\n    color: #6f7f98;\n    font-size: 12px;\n  }\n\n  &__mom-value {\n    font-weight: 600;\n    font-size: 12px;\n\n    &--positive {\n      color: #2f8f4e;\n    }\n\n    &--negative {\n      color: #d93025;\n    }\n  }\n}\n\n.web-analytics-tabs-dashboard .channel-list {\n  gap: 0;\n  margin-top: 12px;\n}\n\n.web-analytics-tabs-dashboard .channel-row {\n  grid-template-columns: minmax(0, 180px) minmax(140px, 1fr) minmax(110px, 144px);\n  gap: 8px;\n  min-height: 42px;\n  padding: 0;\n  border-bottom: 0;\n  font-size: 14px;\n}\n\n.web-analytics-tabs-dashboard .channel-row__name {\n  color: #53647c;\n  font-weight: 500;\n}\n\n.web-analytics-tabs-dashboard .channel-row__bar {\n  min-width: 0;\n  height: 9px;\n  background: #e8edf4;\n  border-radius: 999px;\n  overflow: visible;\n}\n\n.web-analytics-tabs-dashboard .channel-row__bar-fill {\n  background: #2447b8;\n border-radius: 999px;\n}\n\n.web-analytics-tabs-dashboard .channel-row__change {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3px;\n  font-size: 12px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.web-analytics-tabs-dashboard .channel-row__change--pos {\n  color: #2f8f4e !important;\n}\n\n.web-analytics-tabs-dashboard .channel-row__change--neg {\n  color: #ff4b4f !important;\n}\n\n.web-analytics-tabs-dashboard .channel-row__change svg {\n  width: 11px;\n  height: 11px;\n  stroke-width: 2.6;\n}\n\n@media (max-width: 1000px) {\n  .web-analytics-tabs-dashboard .channel-row__bar-tooltip {\n    left: 50%;\n    right: auto;\n    transform: translateX(-50%);\n    min-width: 220px;\n    max-width: min(280px, calc(100vw - 180px));\n    bottom: calc(100% + 10px);\n  }\n\n  .web-analytics-tabs-dashboard .channel-row__bar-tooltip::after {\n    right: calc(50% - 5px);\n  }\n\n  .web-analytics-tabs-dashboard .channel-row__bar-tooltip::before {\n    right: calc(50% - 6px);\n  }\n}\n\n@media (max-width: 900px) {\n  .web-analytics-tabs-dashboard .channel-row {\n    grid-template-columns: minmax(0, min(40%, 200px)) minmax(90px, 1.1fr) minmax(78px, 98px);\n    gap: 8px;\n  }\n}\n\n@media (max-width: 700px) {\n  .web-analytics-tabs-dashboard .channel-row {\n    grid-template-columns: minmax(0, 1fr) minmax(70px, 1fr) minmax(78px, 98px);\n    align-items: center;\n    gap: 8px;\n    padding: 8px 0;\n  }\n\n  .web-analytics-tabs-dashboard .channel-row__change {\n    font-size: 12px;\n  }\n\n  .web-analytics-tabs-dashboard .channel-row__bar {\n    max-width: 92px;\n  }\n}\n\n@media (max-width: 480px) {\n  .web-analytics-tabs-dashboard .channel-row {\n    grid-template-columns: minmax(0, 1fr) minmax(62px, 80px) minmax(64px, 84px);\n    gap: 6px;\n  }\n\n  .web-analytics-tabs-dashboard .channel-row__change {\n    font-size: 11px;\n  }\n\n  .web-analytics-tabs-dashboard .channel-row__bar {\n    max-width: 80px;\n    height: 10px;\n  }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
